import { useMediaQuery } from '@hooks/useMediaQuery';

/**
 * Reactive `prefers-reduced-motion: reduce` flag.
 *
 * Prefer this over inlining `window.matchMedia('(prefers-reduced-motion: reduce)')`
 * so motion handling stays consistent and SSR-safe (see `useMediaQuery`).
 */
export function usePrefersReducedMotion(): boolean {
  return useMediaQuery('(prefers-reduced-motion: reduce)');
}
